<template>
  <v-card class="manage-box" @focusout="handleFocusOut">
    <v-container grid-list-xl class="member-container" >
      <v-layout row wrap v-click-outside="onClickOutside">
        <v-flex v-if="memberCount > 0" class="cardbox">
          <v-card  elevation="8" v-for="memberLists in memeberList" :key="memberLists.id">
            <v-container pb-4 grid-list-xl >
              <v-layout row wrap class="user-detailboxmain">
                <v-flex class="user-detailbox"  @click="onClickOutside">
                  <v-list-item>
                    <v-list-item-avatar v-if="memberLists['gender'] == ('MALE')" style="background-color: skyblue !important">
                      <span class="user-nameshortbox">{{
                        memberLists["name"].match(/\b(\w)/g).join('').toUpperCase().substring(0,2)
                      }}</span>
                    </v-list-item-avatar>
                    <v-list-item-avatar v-else-if="memberLists['gender'] == ('FEMALE')" style="background-color: pink !important">
                      <span class="user-nameshortbox">{{
                        memberLists["name"].match(/\b(\w)/g).join('').toUpperCase().substring(0,2)
                      }}</span>
                    </v-list-item-avatar>
                    <v-list-item-avatar v-else style="background-color: orange !important">
                      <span class="user-nameshortbox">{{
                        memberLists["name"].match(/\b(\w)/g).join('').toUpperCase().substring(0,2)
                      }}</span>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title
                        >
                        <!-- <p class="font-weight-medium user-icon-box" :class="memberLists['gender'] == ('OTHERS') || memberLists['gender'] ==  ('N/A') ? 'default-icon' :(memberLists['type'] == 'Father' || memberLists['type'] == 'Son'  ? 'male-icon':((memberLists['type'] == 'Mother') || (memberLists['type'] == 'Daughter') || (memberLists['type'] == 'Spouse') ? 'female-icon':'female-icon'))">
                          {{ memberLists["name"] }}
                        </p> -->
                        <p>{{ memberLists["name"] }}</p>
                        </v-list-item-title
                      >

                      <v-list-item-subtitle
                        >
                        <p class="font-weight-regular mail-icon" v-if="memberLists['email'] == 'N/A'">&nbsp;</p>
                        <p class="font-weight-regular mail-icon" v-if="memberLists['email'] !== 'N/A'">{{ memberLists["email"] }}</p>
                        </v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-flex>
                <v-flex class="userdetail" @click="onClickOutside">
                  <v-layout row wrap>
                    <v-flex class="s">
                      <p class="member-list-icons" :class="memberLists['type'] == 'Father' ? 'father':((memberLists['type'] == 'Mother') || (memberLists['type'] == 'Spouse') ? 'spouse':'child') ">{{ memberLists["type"] }}</p>
                    </v-flex>
                    <v-flex md6 sm6 xs12>
                      <p v-if="memberLists['dob'] != 'N/A'">Date of Birth</p><p v-if="memberLists['dob'] == 'N/A'"> &nbsp;</p>
                      <p class="font-weight-regular" v-if="memberLists['dob'] !== 'N/A'">{{ memberLists["formatted_dob"] | moment("DD MMM, ****")}}</p>
                      <p v-if="memberLists['dob'] == 'N/A'">
                      </p>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-col class="memberbox-editbox" v-if="allow_user_activity =='yes'">
                   <v-btn
                   class=""
                   outlined
                   fab
                   color="#F19700"
                   @click.prevent="showHide(memberLists['id']),showHideAgain(memberLists['id'])"
                   >
                  <v-img
                       max-height="20"
                       max-width="20"
                       :src="three_dots"
                       :lazy-src="three_dots"
                   ></v-img>
                   </v-btn>
                   <!-- <div v-if="active && hideShow && (hideShowId == memberLists['id'])"> -->
                   <div v-if="active && (hideShowId == memberLists['id'])">
                     <v-btn @click="editMember(memberLists['id'])">
                       <v-img
                         max-height="20"
                         max-width="20"
                         :src="edit_pic"
                         :lazy-src="edit_pic"
                       ></v-img> Edit
                     </v-btn>
                     <v-btn @click="deleteMember(memberLists['id'])">
                       <v-img
                         max-height="23"
                         max-width="19"
                         :src=" delete_pic"
                         :lazy-src=" delete_pic"
                       > </v-img>Delete
                     </v-btn>
                   </div>  
               </v-col>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
        <v-flex v-if="membershipLength == 0" class="cardbox members-manage-botttombox">
          <h4>{{PlanMsg}}</h4>
          <span>Note</span>
          <p>The details of the Investments & the Liabilities may be added for all the listed members. The details of the members may be edited subsequently. Please note that the personal details of members including their date of birth and Permanent Account Number (PAN) shall be masked at all times and can be viewed only by verifying one time password sent to the registered Mobile No. . Nimeya strictly believes in data privacy and doesn’t share your personal and financial information with any third party.</p>
        </v-flex>
       <!--  <v-flex v-if="membershipLength <= 0 || show_add_family_member_button == 0" class="cardbox">
          <p>{{footerMessage}}</p>
        </v-flex> -->
      </v-layout>
    </v-container>
    <v-btn v-if="show_add_family_member_button == 1 && allow_user_activity  !='no'" class="orange-btn btn" @click="addNewMember">
      ADD NEW
    </v-btn>
  </v-card>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'; 
import { GET_INVESTOMETER_DETAIL, GET_FAMILY_MEMBER_LIST, DELETE_FAMILY_MEMBER, UPDATE_PROFILE_DETAIL } from "../../store/actions.type";
import ApiService from '../../api/api.service';
import JwtService from ".././common/jwt.service";
/*Vue.directive("click-outside", {
  bind(el, binding, vnode) {
    el.clickOutsideEvent = (event) => {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  },
  stopProp(event) { event.stopPropagation() }
});*/

export default {
  components: {},
  data: () => ({
    memeberList: [],
    hideShow:false,
    hideShowId:'',
    randomColor:'',
    classVariables:'',
    three_dots:process.env.VUE_APP_ROOT_ICONS_URL + 'three_dots.png',
    edit_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'edit.png',
    delete_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'delete.png',
    allow_add_family_member:'',
    memberCount:'',
    show_add_family_member_button:'',
    error_message:'',
    buttonDissable:1,
    cancelChangeArray:[],
    footerMessage:'',
    membershipLength:0,
    cancelButton:'',
    PlanMsg:null,
    plan_type:null,
    active: true,
    allow_user_activity:localStorage.getItem('allow_user_activity')
  }),
  created() {
    
    Fire.$on("picRefresh", () => {
      this.membershipData('default');
    });
    
    this.planChangeMgs()

    
  },
  mounted(){
    this.membershipData('default')
    Fire.$emit("picRefresh");
  },
  methods: {
    planChangeMgs(){
      let plan_type = this.$store.getters.getInvestometerDetail.plan_type;
      if(plan_type == "Gold"){
        this.PlanMsg = 'You can add upto 6 members including yourself under Gold Option';
      }
      else if(plan_type == "Platinum"){
        this.PlanMsg = 'You can add upto 15 members including yourself under Platinum Option';
      }
      else{
         this.PlanMsg = 'You can not add members for Silver Option';
      }
    },
    onClickOutside () {
      this.active = false
    },
    addNewMember() {

      this.allow_add_family_member == 0 ? 
       swal
        .fire({
          title: "To add more members please upgrade your subscription",
          showDenyButton: true,
          icon: 'warning',
         // showCancelButton: true,
          confirmButtonText: `Ok`,
          //denyButtonText: `NO`
        })
      : this.$router.push({ name: "AddNewMember" }).catch(()=>{});
    },
    editMember(editId) {
      this.$router.push({ path: "/EditNewMember/"+btoa(editId) }).catch(()=>{});
    },
    deleteMember(deleteId) {
      swal
        .fire({
          title: "Are you sure, You want to delete this member?",
          showCancelButton: true,
          confirmButtonColor: `#051d42`,
          confirmButtonText: `YES`,
          cancelButtonColor: `#f19700`,
        })
        .then(result => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            Fire.$emit('membershipUpdate');
            let api_token   = localStorage.getItem("api_token");
            this.$store.dispatch(DELETE_FAMILY_MEMBER, {
              data: {
                aws_cognito_id: atob(localStorage.getItem('cognito_idp')),
                member_id: deleteId,
              },
              api: 'delete-family-member', 
            }).then(() => {
              Toast.fire({
                icon: 'success',
                title: 'Member deleted successfully.'
              })
              Fire.$emit('updateMember');
              this.membershipData('after_delete');
              setTimeout(() => {
                this.$router.push({ name: 'dashboard' }).catch(()=>{})
              }, 2000);
            })
            .catch(function (error) {
            });
          } else if (result.isDenied) {
            Swal.fire("Changes are not saved", "", "info");
          }
        });
    },
    showHide(id){
      this.active =this.active ? false : true;
      this.hideShowId = id;
      this.hideShow = this.hideShow ? false : true;
    },
    showHideAgain(id){
      this.cancelChangeArray.push(id);
      if (this.cancelChangeArray.length > 1 && this.cancelChangeArray[this.cancelChangeArray.length -2] != id) {
        this.hideShow = true;
      }
      
    },
    handleFocusOut(){
      this.hideShow = false;
    },
    membershipData(type){
      this.appendMemberData();
      setTimeout(()=>{
        if(this.$store.getters.getProfileDetail.data != undefined){
          if(type=='default'){
            if(this.$store.getters.getProfileDetail.data == undefined){
              this.appendMemberData();
            }
            else{
              let response = this.$store.getters.getProfileDetail.data
              this.memeberList = response.family_member_list;
              this.memberCount = response.family_member_list.length
              this.allow_add_family_member = response.allow_add_family_member;
              this.show_add_family_member_button = response.show_add_family_member_button;
              if (response.show_add_family_member_button != null) {
                this.buttonDissable =  response.show_add_family_member_button;
              }
              this.membershipLength = response.family_member_list.length;
            } 
          }
          else if(type =='after_delete'){
            this.appendMemberData();
          }
          else{
            this.appendMemberData(); 
          }  
        }
      }, 1000)
    },

    appendMemberData(){
      this.$store.dispatch(GET_FAMILY_MEMBER_LIST, {
        data: {
          aws_cognito_id: atob(localStorage.getItem('cognito_idp')),
        },
        api: 'get-family-member-list', 
      }).then(() => {
        let response = this.$store.getters.getFamilyMemberList;
          if (response.status == 'error') {
            this.error_message = response.message;
            return [];
          }
          else {
          let updatedDetail = [
            {key:'allow_add_family_member', value:response.allow_add_family_member},
            {key:'show_add_family_member_button', value:response.show_add_family_member_button},
            {key:'family_member_list', value:response.data},
          ]
          this.$store.dispatch(UPDATE_PROFILE_DETAIL,updatedDetail)
          this.memeberList = response.data;
          this.membershipLength = this.memeberList.length;
          this.memberCount = response.data.length
          this.allow_add_family_member = response.allow_add_family_member;
          this.show_add_family_member_button = response.show_add_family_member_button;
          this.buttonDissable =  response.show_add_family_member_button;
          this.footerMessage = response.plan_mgs;
        }
      });
      
    }
  },
};
</script>
